/* eslint-disable @angular-eslint/prefer-standalone */
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

import { ActivatedRoute } from '@angular/router';
import { Checkbox } from '@interfaces/a-organizar/checkbox';
import { TranslationKeys } from '@internationalization/translation-keys';
import { LoginRequest } from '@models/auth/login-request';
import { UtilsService } from '@services/helpers/utils.service';
import { AuthenticationService } from '@services/http/authentication.service';
import { VaultBaseComponent } from '@shared/components/base/vault-base.component';
import { nameof } from '@src/app/core/utils/nameof.utils';
import { selectAuthState, selectLoadingMessage } from '@state/auth/auth.selectors';
import { AuthState } from '@state/auth/auth.state';
import { AppState } from '@state/index';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false,
})
export class LoginFormComponent extends VaultBaseComponent implements OnInit {
  @Input() companyId: string = '';
  @Input() tenantId: string = '';
  @Output() sendFormModeChange = new EventEmitter<string>();

  public currentAuthState: AuthState = {} as AuthState;
  private destroy$ = new Subject<void>();
  public loginProps = nameof<LoginRequest>();

  loginForm: FormGroup = this.formBuilder.group({
    [this.loginProps.email]: ['', [Validators.required, Validators.email]],
    [this.loginProps.password]: ['', [Validators.required, Validators.minLength(6)]],
  });
  checkbox: Checkbox | null = null;
  loadingMessage: string | undefined;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef,
    store: Store<AppState>,
    translateService: TranslateService
  ) {
    super(translateService, store);
    if (this.store) {
      this.store
        .select(selectAuthState)
        .pipe(takeUntil(this.destroy$))
        .subscribe((authState: AuthState) => {
          this.currentAuthState = authState;
        });
    }

    this.loadingMessage = translateService.instant(TranslationKeys.General.Loading);
  }

  ngOnInit() {
    if (this.store) {
      this.store.select(selectLoadingMessage).subscribe(loading => {
        this.loadingMessage = loading;
        this.cdr.detectChanges();
      });
    }
  }

  async doLogin() {
    const pathToRedirect = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';

    this.isLoading = true;
    try {
      await this.authenticationService.performLogin(
        this.loginForm.value as LoginRequest,
        this.loginForm,
        pathToRedirect,
        null
      );
    } catch (error) {
      this.isLoading = false;
      console.error('Login error:', error);
    }
  }

  handleFormMode(formMode: string) {
    this.sendFormModeChange.emit(formMode);
  }

  handleCheckboxChange(checkbox: Checkbox, controlName: string) {
    this.loginForm.get(controlName)?.setValue(checkbox.isChecked);
    this.checkbox = checkbox;
  }
}
